module.exports = __webpack_public_path__ + "img/Blog-Image.47921481.png";